/* =====================================================================
   LE PETIT BISCUIT FRANÇAIS — Module « Formats » (multi-format générique)
   ---------------------------------------------------------------------
   Remplace l'ancien sélecteur 6/16. Affiche, sur les coffrets à thème,
   la même interface que le biscuit personnalisable : des lignes de
   format avec compteur de quantité, paliers minimum, total, et un seul
   bouton « Ajouter au panier » qui envoie plusieurs lignes d'un coup.

   • Ne s'active QUE sur les produits à UNE SEULE option dont au moins
     une variante est reconnue comme un format connu.
   • N'est jamais chargé sur le « biscuit à personnaliser » (le bloc
     chargeur du template l'exclut par product.id).
   • Les produits à double option (coffret Maîtresse/Maître) sont
     ignorés : le sélecteur natif de Shopify reste intact.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__LPBF_FMT_INIT) return;
  window.__LPBF_FMT_INIT = true;

  // Le bloc chargeur du template fournit déjà window.LPBF_COFFRET
  // ({id,title,price,available}). window.LPBF_FORMATS est accepté en alias.
  var VARIANTS = window.LPBF_FORMATS || window.LPBF_COFFRET || [];
  var VIDEO = window.LPBF_C6_VIDEO || '';
  var IMG = window.LPBF_IMG || '';
  if (!VARIANTS.length) return;

  // Vidéo du Grand Coffret (la même que sur la fiche du biscuit personnalisé) : avant, la bulle
  // « Grand Coffret » rejouait la vidéo du petit coffret.
  var VIDEO_C16 = 'https://lepetitbiscuitfrancais.fr/cdn/shop/videos/c/vp/6e82bbdfa91c419caf75c744b277e4c4/6e82bbdfa91c419caf75c744b277e4c4.HD-1080p-7.2Mbps-46690810.mp4?v=0';
  // Vidéos des sachets de 2 et des sachets individuels, les mêmes que sur la fiche du biscuit
  // personnalisé (demande de Fabien le 22/09/2026 : avant, ces bulles montraient la photo du coffret)
  var VIDEO_S2 = 'https://lepetitbiscuitfrancais.fr/cdn/shop/videos/c/vp/9b6dd33e996b4b7eb25fa3830ef5b5c3/9b6dd33e996b4b7eb25fa3830ef5b5c3.HD-1080p-2.5Mbps-59124970.mp4?v=0';
  var VIDEO_U1 = 'https://lepetitbiscuitfrancais.fr/cdn/shop/videos/c/vp/c92449dd3b364ac8857ae8070a59d3c3/c92449dd3b364ac8857ae8070a59d3c3.HD-1080p-2.5Mbps-59124727.mp4?v=0';
  // Coffrets qui ont leur propre vidéo de petit coffret (le bon message dans le bon conditionnement) :
  // elle remplace la vidéo générique dans la bulle « Petit Coffret ». Demande de Fabien le 22/09/2026,
  // Marraine seulement.
  var PROPRES = {
    'coffret-marraine': {
      c6: 'https://lepetitbiscuitfrancais.fr/cdn/shop/videos/c/vp/c86bea7554b54bd0b3a3a137775c41b5/c86bea7554b54bd0b3a3a137775c41b5.HD-1080p-7.2Mbps-46690842.mp4?v=0',
      img: 'https://lepetitbiscuitfrancais.fr/cdn/shop/files/preview_images/couverture-video-marraine.jpg?width=240'
    }
  };
  var PROPRE = PROPRES[(location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1]] || null;
  // Stories de l'appli (ronds vidéo en haut de fiche) masquées sur tous les coffrets à thème :
  // doublon des bulles du bloc Conditionnement, et noires une fois la vidéo finie (Fabien, 01/10/2026).
  // Masquées seulement, pas retirées : grabVideos() y lit encore les vidéos de format.
  var stSt = document.createElement('style');
  stSt.textContent = '.orsay-thumbnail-stories{display:none !important;}';
  document.head.appendChild(stSt);
  // Dossier des fichiers du thème, déduit de l'adresse de ce script (…/assets/lpbf-coffret.js)
  var ASSETS = ((document.currentScript && document.currentScript.src) || '').replace(/lpbf-coffret\.js.*$/, '');
  // Image fixe de chaque bulle, selon la vidéo qu'elle ouvre (chantier 13, 21/09/2026)
  var POSTERS = { c413e36c20a34fa187894ed0d22b95e7: 'lpbf-video-coffret-6.jpg', '6e82bbdfa91c419caf75c744b277e4c4': 'lpbf-video-coffret-16.jpg',
    '9b6dd33e996b4b7eb25fa3830ef5b5c3': 'lpbf-video-sachet-2.jpg', c92449dd3b364ac8857ae8070a59d3c3: 'lpbf-video-unite.jpg' };
  function poster(src) {
    if (PROPRE && src === PROPRE.c6) return PROPRE.img;
    for (var id in POSTERS) { if (src.indexOf(id) !== -1 && ASSETS) return ASSETS + POSTERS[id]; }
    return productImage();
  }

  // Image de repli pour les pastilles sans vidéo : le visuel principal du produit
  function productImage() {
    if (IMG) return IMG;
    var im = document.querySelector('.product__media img, .product-media img, .product__media-item img');
    return (im && (im.currentSrc || im.src)) || '';
  }

  var S = window.__LPBF_FMT_STATE = window.__LPBF_FMT_STATE || { qty: {} };

  /* ------------------------------------------------------------------
     1. Dictionnaire des formats
     ------------------------------------------------------------------ */
  var DEFAULTS = [
    // Petit coffret sans minimum sur les coffrets à thème (décision de Fabien le 22/09/2026 :
    // message déjà composé, bien moins contraignant à produire). Le biscuit à message libre
    // (lpbf-multiformat.js) garde son minimum de 4.
    { key: 'C6',  group: 'Avec coffret', title: 'Petit Coffret',         sub: '6 biscuits',  min: 1,  n: 6,  many: 'coffrets', unit: 'le coffret', cap: 'Coffret 6',  test: function (t) { return /(?:^|[^0-9])6\s*biscuit/i.test(t); } },
    { key: 'C16', group: 'Avec coffret', title: 'Grand Coffret',         sub: '16 biscuits', min: 1,  n: 16, many: 'coffrets', unit: 'le coffret', cap: 'Coffret 16', test: function (t) { return /(?:^|[^0-9])16\s*biscuit/i.test(t); } },
    { key: 'S15', group: 'Sans coffret', title: 'Sachet de 15 biscuits', sub: '',                 min: 1,  n: 15, many: 'sachets',  unit: 'le sachet',  cap: 'Sachet 15',  test: function (t) { return /(?:^|[^0-9])15\s*biscuit/i.test(t); } },
    { key: 'S2',  group: 'Sans coffret', title: 'Sachet de 2 biscuits',  sub: '',                  min: 10, n: 2,  many: 'sachets',  unit: 'le sachet',  cap: 'Sachet 2',   test: function (t) { return /(?:^|[^0-9])2\s*biscuit/i.test(t) || /sachet\s*de\s*2/i.test(t); } },
    { key: 'U1',  group: 'Sans coffret', title: 'Biscuit à l’unité', sub: 'en sachet individuel',               min: 20, n: 1,  many: 'biscuits', unit: 'le biscuit', cap: 'À l’unité', test: function (t) { return /unit[ée]|individuel/i.test(t); } }
  ];
  var ORDER = ['C6', 'C16', 'S15', 'S2', 'U1'];

  function classify(title) {
    title = title || '';
    // L'unité en premier : « Biscuit à l'unité » ne doit pas être capté par le test « 2 biscuits »
    for (var i = DEFAULTS.length - 1; i >= 0; i--) {
      if (DEFAULTS[i].test(title)) return DEFAULTS[i];
    }
    return null;
  }

  /* ------------------------------------------------------------------
     2. Construction du modèle
     ------------------------------------------------------------------ */
  var seen = {};
  var ROWS = [];
  VARIANTS.forEach(function (v) {
    var d = classify(v.title);
    if (!d || seen[d.key]) return;
    seen[d.key] = true;
    ROWS.push({
      key: d.key, group: d.group, title: d.title, sub: d.sub,
      min: d.min, n: d.n, many: d.many, unit: d.unit, cap: d.cap,
      nativeValue: (v.title || '').trim(), v: v
    });
  });
  ROWS.sort(function (a, b) { return ORDER.indexOf(a.key) - ORDER.indexOf(b.key); });
  if (!ROWS.length) return;

  // 23/09/2026 : aucun format n'est choisi d'office (même raison que sur la fiche biscuit,
  // voir lpbf-multiformat.js) — un coffret non demandé ne doit jamais arriver seul au panier.
  function preselect() { S.qty = {}; }
  if (!S.pre) { S.pre = true; preselect(); }
  // Le minimum dit avant le clic, en court : « À partir de 10 sachets », « À partir de 20 biscuits »
  // (Fabien le 01/10/2026 : « simple, efficace et compréhensible » ; avant : « …, soit 20 biscuits : 20,00 € »).
  function minNote(r) {
    return 'À partir de ' + r.min + ' ' + r.many;
  }

  function euro(cents) {
    var n = Number(cents) / 100;
    return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  // Titres de groupe : l'usage plutôt que l'emballage (chantier 14, 21/09/2026, version B)
  // Deux blocs distincts (version A, validée par Fabien le 22/09/2026 : https://claude.ai/artifact/7LqvRuoQvhBqZ9MjjgzPTZ) :
  // coffret sur fond crème, sachets sur fond blanc à bord pointillé, pictogramme + étiquette d'usage.
  var GROUPES = {'Avec coffret':{k:'c',t:'Coffret cadeau',s:'Prêt à offrir, ensachés par 2',tag:'À offrir',svg:'<svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true" focusable="false"><rect x="4" y="12" width="22" height="14" rx="2" fill="none" stroke="#8A521E" stroke-width="1.8"/><rect x="3" y="8" width="24" height="5" rx="1.5" fill="none" stroke="#8A521E" stroke-width="1.8"/><path d="M15 8v18M15 8c-2-4-7-5-7-2s5 2 7 2c2 0 7 1 7-2s-5-2-7 2" fill="none" stroke="#8A521E" stroke-width="1.6"/></svg>'},'Sans coffret':{k:'s',t:'Sachets à distribuer',s:'Sans coffret : mariage, classe, entreprise',tag:'En nombre',svg:'<svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true" focusable="false"><path d="M8 9h14l2 17H6z" fill="none" stroke="#5C4F40" stroke-width="1.8" stroke-linejoin="round"/><path d="M8 9l2-4h10l2 4" fill="none" stroke="#5C4F40" stroke-width="1.6"/><path d="M11 15h8" stroke="#5C4F40" stroke-width="1.6"/></svg>'}};
  function groupe(g) {
    var d = GROUPES[g] || { k: 's', t: g, s: '', tag: '', svg: '' }, b = el('div', 'blk ' + d.k), w = el('div', 'grp'), x = el('div', 'gx'), t = el('div', 'gt', d.t);
    if (d.svg) w.insertAdjacentHTML('beforeend', d.svg);
    t.setAttribute('role', 'heading'); t.setAttribute('aria-level', '3'); x.appendChild(t);
    if (d.s) x.appendChild(el('div', 'gs', d.s));
    w.appendChild(x);
    if (d.tag) w.appendChild(el('span', 'tag', d.tag));
    b.appendChild(w);
    return b;
  }

  /* ------------------------------------------------------------------
     3. Styles
     ------------------------------------------------------------------ */
  function injectCSS() {
    if (document.getElementById('lpbf-fmt-css')) return;
    var css = ''
      + '#lpbf-fmt{margin:6px 0 4px;font-family:inherit;}'
      + '#lpbf-fmt .fi{display:flex;align-items:center;gap:12px;margin:0 0 16px;}'
      + '#lpbf-fmt .fi-vid{position:relative;width:56px;height:56px;flex:0 0 56px;border-radius:50%;overflow:hidden;cursor:pointer;border:2px solid #E7D3BF;box-shadow:0 2px 8px rgba(58,44,30,.14);background:#f3e8dd;}'
      + '#lpbf-fmt .fi-vid video,#lpbf-fmt .fi-vid img{width:100%;height:100%;object-fit:cover;display:block;}'
      + '#lpbf-fmt .fi-vid.has-vid::after{content:"";position:absolute;left:50%;top:50%;transform:translate(-42%,-50%);border-style:solid;border-width:8px 0 8px 13px;border-color:transparent transparent transparent #fff;filter:drop-shadow(0 1px 1px rgba(0,0,0,.4));opacity:.95;}'
      + '#lpbf-fmt .fi-tx{font-size:13px;line-height:1.35;color:#5A4632;}'
      + '#lpbf-fmt .fi-tx b{color:#3A2C1E;}'
      + '#lpbf-fmt .kick{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#B3702F;font-weight:700;margin:0 0 5px;}'
      + '#lpbf-fmt .lead{font-size:12.5px;color:rgba(18,18,18,.45);margin-bottom:6px;}'
      + '#lpbf-fmt .grp{margin:18px 0 10px;padding-left:2px;}'
      + '#lpbf-fmt .grp .gt{font-family:Georgia,"Times New Roman",serif;font-size:19px;line-height:1.2;color:#3A2C1E;}'
      + '#lpbf-fmt .grp .gs{font-size:12.5px;line-height:1.4;color:#6F6152;margin-top:3px;}'
      + '#lpbf-fmt .blk{border-radius:16px;padding:12px 6px 2px;margin:12px 0 14px;}'
      + '#lpbf-fmt .blk.c{background:#F7EDE3;border:1px solid #ead7c2;}'
      + '#lpbf-fmt .blk.s{background:#fff;border:1.5px dashed #cdbfae;}'
      + '#lpbf-fmt .blk .grp{display:flex;align-items:center;gap:10px;margin:0 4px 10px;padding:0;}'
      + '#lpbf-fmt .blk .grp svg{flex:0 0 auto;}'
      + '#lpbf-fmt .blk .grp .gx{flex:1;min-width:0;}'
      + '#lpbf-fmt .blk .grp .gt{font-size:18px;}'
      + '#lpbf-fmt .blk .grp .gs{margin-top:1px;}'
      + '#lpbf-fmt .blk .tag{flex:0 0 auto;font-size:10.5px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;border-radius:99px;padding:3px 8px;white-space:nowrap;}'
      + '#lpbf-fmt .blk.c .tag{background:#8A521E;color:#fff;}'
      + '#lpbf-fmt .blk.s .tag{background:#EDE8E1;color:#5C4F40;}'
      + '#lpbf-fmt .blk .row{background:#fff;padding:12px 11px;}'
      + '#lpbf-fmt .blk .row.on{padding:11px 10px;}'
      + '#lpbf-fmt .row{display:flex;align-items:center;gap:14px;border:1px solid rgba(18,18,18,.12);border-radius:14px;padding:12px 14px;margin-bottom:10px;transition:border-color .15s,box-shadow .15s;}'
      + '#lpbf-fmt .row.on{border-color:#B3702F;border-width:2px;padding:11px 13px;box-shadow:0 0 0 3px rgba(179,112,47,.08);}'
      + '#lpbf-fmt .row.out{opacity:.45;}'
      + '#lpbf-fmt .bub{order:2;flex:0 0 62px;width:62px;display:flex;flex-direction:column;align-items:center;gap:6px;border:0;padding:4px 0 0;margin:0;background:none;font:inherit;color:inherit;}'
      + '#lpbf-fmt button.bub{cursor:pointer;}'
      + '#lpbf-fmt .bub .ring{width:56px;height:56px;border-radius:50%;background:#f2ece3 center/cover no-repeat;position:relative;box-shadow:0 0 0 2px #fff,0 0 0 4px #B3702F;}'
      + '#lpbf-fmt .bub .play{position:absolute;right:-5px;bottom:-5px;width:22px;height:22px;border-radius:50%;background:#8A521E;box-shadow:0 0 0 2px #fff;}'
      + '#lpbf-fmt .bub .play:after{content:"";position:absolute;top:50%;left:54%;transform:translate(-50%,-50%);border-left:8px solid #fff;border-top:5px solid transparent;border-bottom:5px solid transparent;}'
      + '#lpbf-fmt .bub .lbl{font-size:10.5px;font-weight:700;line-height:1.1;color:#8A521E;letter-spacing:.02em;white-space:nowrap;}'
      + '#lpbf-fmt .bub:focus-visible{outline:2px solid #B3702F;outline-offset:3px;border-radius:10px;}'
      + '#lpbf-fmt .nf{order:0;flex:1;min-width:0;}'
      + '#lpbf-fmt .ti{font-family:Georgia,"Times New Roman",serif;font-size:15.5px;color:#3A2C1E;line-height:1.15;}'
      + '#lpbf-fmt .row.on .ti{color:#96591f;}'
      + '#lpbf-fmt .su{font-size:11.5px;color:rgba(18,18,18,.45);margin-top:2px;}'
      + '#lpbf-fmt .pr{font-family:Georgia,"Times New Roman",serif;font-size:15px;margin-top:3px;color:#3A2C1E;}'
      + '#lpbf-fmt .pr .u{font-size:11.5px;color:#6F6152;}'
      + '#lpbf-fmt .row{flex-wrap:wrap;row-gap:8px;}'
      + '#lpbf-fmt .mnote{order:3;flex:0 0 100%;font-size:12px;line-height:1.35;color:#8A521E;background:#F7EDE3;border-radius:6px;padding:5px 9px;margin-top:2px;}'
      + '#lpbf-fmt .qc{order:1;display:flex;flex-direction:column;align-items:center;gap:5px;}'
      + '#lpbf-fmt .stp{display:flex;align-items:center;border:1px solid rgba(18,18,18,.12);border-radius:10px;overflow:hidden;}'
      + '#lpbf-fmt .stp{overflow:visible !important;background:#fff;}#lpbf-fmt .stp button:first-child{border-radius:9px 0 0 9px;}#lpbf-fmt .stp button:last-child{border-radius:0 9px 9px 0;}#lpbf-fmt .stp button::after{content:"";position:absolute;inset:-2px -4px;}#lpbf-fmt .stp button{position:relative;width:36px;height:40px;padding:0;border:0;background:#fff;font-size:18px;color:#3A2C1E;cursor:pointer;line-height:1;padding:0;}'
      + '#lpbf-fmt .stp button:hover{background:#faf6f0;}'
      + '#lpbf-fmt .stp .q{width:30px;text-align:center;font-family:Georgia,"Times New Roman",serif;font-size:15px;}'
      + '#lpbf-fmt .stp.z .q{color:rgba(18,18,18,.45);}'
      + '#lpbf-fmt .ls{font-family:Georgia,"Times New Roman",serif;font-size:13px;color:#96591f;line-height:1;}'
      + '#lpbf-fmt .ls.h{display:none;}'
      + '#lpbf-fmt .rc{margin-top:16px;border-top:1px solid rgba(18,18,18,.12);padding-top:14px;}'
      + '#lpbf-fmt .rl{display:flex;justify-content:space-between;font-size:13px;color:rgba(18,18,18,.45);margin-bottom:6px;}'
      + '#lpbf-fmt .gr{display:flex;justify-content:space-between;align-items:baseline;margin-top:6px;}'
      + '#lpbf-fmt .gr .t{font-family:Georgia,"Times New Roman",serif;font-size:23px;color:#3A2C1E;}'
      + '#lpbf-fmt .cta{width:100%;margin-top:14px;background:#3A2C1E;color:#fff;border:0;border-radius:30px;min-height:56px;padding:0 22px;display:flex;align-items:center;justify-content:center;gap:10px;font:700 16.5px/1.1 var(--font-body-family),"Lato",Arial,sans-serif;letter-spacing:.01em;cursor:pointer;box-shadow:0 6px 16px -6px rgba(58,44,30,.55);}#lpbf-fmt .cta:hover:not(:disabled){background:#2A1F15;}#lpbf-fmt .cta:not(:disabled)::before{content:"";flex:0 0 18px;width:18px;height:18px;background:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2018%2018%27%3E%3Cpath%20d=%27M3%205h12l-1.2%208H4.2z%20M6.5%205V4a2.5%202.5%200%200%201%205%200v1%27%20fill=%27none%27%20stroke=%27black%27%20stroke-width=%271.7%27%20stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2018%2018%27%3E%3Cpath%20d=%27M3%205h12l-1.2%208H4.2z%20M6.5%205V4a2.5%202.5%200%200%201%205%200v1%27%20fill=%27none%27%20stroke=%27black%27%20stroke-width=%271.7%27%20stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/contain no-repeat;}'
      + '#lpbf-fmt .cta:disabled{background:#c9beb0;cursor:not-allowed;box-shadow:none;}'
      + '#lpbf-fmt .note{font-size:11px;color:rgba(18,18,18,.45);text-align:center;margin-top:10px;}'
      + '#lpbf-fmt-lb{position:fixed;inset:0;z-index:99999;background:rgba(30,20,12,.86);display:none;align-items:center;justify-content:center;padding:18px;}'
      + '#lpbf-fmt-lb.on{display:flex;}'
      + '#lpbf-fmt-lb .box{position:relative;max-width:420px;width:100%;background:#000;border-radius:16px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.5);}'
      + '#lpbf-fmt-lb video{width:100%;display:block;max-height:80vh;background:#000;}'
      + '#lpbf-fmt-lb .x{position:absolute;top:10px;right:10px;width:36px;height:36px;border-radius:50%;border:0;background:rgba(255,255,255,.94);color:#3A2C1E;font-size:18px;cursor:pointer;z-index:2;line-height:1;}'
      + '#lpbf-fmt-lb .cap{color:#fff;font-family:Georgia,"Times New Roman",serif;font-size:14px;line-height:1.4;text-align:center;padding:12px 14px 14px;background:#1E140C;}'
      + '#lpbf-fmt-lb .cap:empty{display:none;}'
      + '#lpbf-fmt-lb .cap b{display:block;font-weight:700;}'
      + '#lpbf-fmt-lb .cap span{display:block;font-size:13px;opacity:.92;}';
    var s = document.createElement('style');
    s.id = 'lpbf-fmt-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------------
     4. Lightbox vidéo
     ------------------------------------------------------------------ */
  // Légende de la vidéo (01/10/2026, demande de Fabien) : le format ouvert, puis le message
  // tamponné sur les biscuits de ce coffret. Le message vient du métachamp produit
  // custom.message_biscuit, affiché tel quel. Rien sur la fiche « biscuit à personnaliser »,
  // qui a son propre module (lpbf-multiformat.js).
  var MSG = (window.LPBF_MSG || '').trim();
  var FORMATS = {
    C6: 'Petit coffret · 6 biscuits',
    C16: 'Grand coffret · 16 biscuits',
    S15: 'Sachets de 15 biscuits',
    S2: 'Sachets de 2 biscuits',
    U1: 'Biscuit à l\u2019unit\u00e9, en sachet'
  };
  function legende(row) {
    var l2 = MSG
      ? (row.key === 'U1' ? 'Le vôtre portera : ' : 'Les vôtres porteront : ') + MSG
      : 'Les vôtres porteront le message de ce coffret.';
    return { t: FORMATS[row.key] || row.title, s: l2 };
  }

  function openLightbox(src, caption) {
    if (!src) return;
    var lb = document.getElementById('lpbf-fmt-lb');
    if (!lb) {
      lb = el('div'); lb.id = 'lpbf-fmt-lb';
      var box = el('div', 'box');
      var x = el('button', 'x', '✕'); x.type = 'button'; x.setAttribute('aria-label', 'Fermer');
      var vd = document.createElement('video'); vd.id = 'lpbf-fmt-lb-v'; vd.controls = true; vd.loop = true; vd.setAttribute('playsinline', '');
      var cp = el('div', 'cap'); cp.id = 'lpbf-fmt-lb-cap';
      box.appendChild(x); box.appendChild(vd); box.appendChild(cp); lb.appendChild(box);
      document.body.appendChild(lb);
      var close = function () { lb.classList.remove('on'); try { vd.pause(); } catch (e) {} document.body.style.overflow = ''; };
      x.onclick = close;
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    var v = document.getElementById('lpbf-fmt-lb-v');
    v.src = src; v.muted = false; try { v.currentTime = 0; } catch (e) {}
    var cap = document.getElementById('lpbf-fmt-lb-cap');
    cap.textContent = '';
    if (caption && caption.t) {
      var b = document.createElement('b'); b.textContent = caption.t;
      var sp = document.createElement('span'); sp.textContent = caption.s || '';
      cap.appendChild(b); if (caption.s) cap.appendChild(sp);
    } else if (caption) {
      cap.textContent = caption;
    }
    lb.classList.add('on'); document.body.style.overflow = 'hidden';
    try { v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); } catch (e) {}
  }

  /* ------------------------------------------------------------------
     5. Détection de la page + masquage du natif
     ------------------------------------------------------------------ */
  function nativeRadios() {
    return Array.prototype.slice.call(
      document.querySelectorAll('variant-selects input[type="radio"], .product-form__input input[type="radio"]')
    );
  }
  function optionGroupCount() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return 0;
    var selects = vs.querySelectorAll('select').length;
    var names = {};
    nativeRadios().forEach(function (r) { names[(r.name || '').trim()] = 1; });
    return selects + Object.keys(names).length;
  }
  function isSinglePage() {
    if (optionGroupCount() !== 1) return false;
    return nativeRadios().some(function (r) { return !!classify(r.value); });
  }
  function hideNatives() {
    var vs = document.querySelector('variant-selects');
    if (vs && vs.style.display !== 'none') vs.style.setProperty('display', 'none', 'important');
    var q = document.querySelector('input[name="quantity"]');
    q = q && q.closest('.product-form__quantity, .product-form__input');
    if (q && q.style.display !== 'none') q.style.setProperty('display', 'none', 'important');
    var b = document.querySelector('.product-form__buttons');
    if (b && b.style.display !== 'none') b.style.setProperty('display', 'none', 'important');
  }

  /* ------------------------------------------------------------------
     6. Vidéos de formats récupérées depuis les stories de la fiche
     ------------------------------------------------------------------ */
  var vids = {};
  function grabVideos() {
    if (VIDEO) { vids.C6 = vids.C6 || VIDEO; vids.C16 = vids.C16 || VIDEO_C16; }
    vids.S2 = vids.S2 || VIDEO_S2; vids.U1 = vids.U1 || VIDEO_U1;
    document.querySelectorAll('.orsay-thumbnail-story').forEach(function (s) {
      var lbl = (s.textContent || '');
      var v = s.querySelector('video'); if (!v) return;
      var so = v.querySelector('source');
      var src = (so && so.getAttribute('src')) || v.getAttribute('src') || v.currentSrc || '';
      if (!src) return;
      if (/16/.test(lbl)) vids.C16 = src;
      else if (/unit[ée]|individuel/i.test(lbl)) vids.U1 = src;
      else if (/sachet/i.test(lbl) && /15/.test(lbl)) vids.S15 = src;
      else if (/sachet/i.test(lbl) && /2/.test(lbl)) vids.S2 = src;
    });
    if (PROPRE) vids.C6 = PROPRE.c6;
  }

  /* ------------------------------------------------------------------
     7. Rendu
     ------------------------------------------------------------------ */
  // Bulle vidéo : image fixe, pastille lecture, « Voir la vidéo » en toutes lettres.
  // La vidéo ne se télécharge qu'au clic (avant : vidéos en boucle dans chaque bulle).
  function bubble(row) {
    var src = vids[row.key], b, ring = el('span', 'ring'), img;
    if (src) {
      b = el('button', 'bub'); b.type = 'button'; b.setAttribute('aria-label', 'Voir la vidéo : ' + row.title);
      img = poster(src);
      ring.appendChild(el('span', 'play'));
      b.appendChild(ring); b.appendChild(el('span', 'lbl', 'Voir la vidéo'));
      b.addEventListener('click', function () { openLightbox(src, legende(row)); });
    } else {
      b = el('span', 'bub'); b.setAttribute('aria-hidden', 'true');
      img = productImage();
      b.appendChild(ring);
    }
    if (img) ring.style.backgroundImage = 'url("' + img + '")';
    return b;
  }

  function build() {
    var vs = document.querySelector('variant-selects');
    if (!vs || !isSinglePage()) return false;

    injectCSS();
    grabVideos();

    var existing = document.getElementById('lpbf-fmt');
    if (existing && existing.parentNode) { hideNatives(); recompute(); return true; }

    var wrap = el('div'); wrap.id = 'lpbf-fmt';

    // Vidéo d'intro « Coffret cadeau, prêt à offrir » retirée le 22/09/2026 (Fabien) : elle
    // doublonnait la bulle vidéo du petit coffret et le titre du bloc « Coffret cadeau », et
    // téléchargeait la vidéo en boucle dès l'arrivée sur la page.
    wrap.appendChild(el('div', 'kick', 'Conditionnement'));

    var lastGroup = null, blk = wrap;
    ROWS.forEach(function (r) {
      if (r.group !== lastGroup) { blk = groupe(r.group); wrap.appendChild(blk); lastGroup = r.group; }
      var out = r.v && r.v.available === false;
      var row = el('div', 'row' + (out ? ' out' : ''));
      row.setAttribute('data-k', r.key);

      var nf = el('div', 'nf');
      nf.appendChild(el('div', 'ti', r.title));
      if (r.sub) nf.appendChild(el('div', 'su', r.sub));
      var pr = el('div', 'pr');
      pr.appendChild(el('span', 'pn', euro(r.v.price)));
      pr.appendChild(document.createTextNode(' '));
      pr.appendChild(el('span', 'u', out ? '· indisponible' : r.unit));
      nf.appendChild(pr);

      var qc = el('div', 'qc');
      var stp = el('div', 'stp z');
      var mn = el('button', 'mn', '−'); mn.type = 'button'; mn.setAttribute('aria-label', 'Retirer : ' + r.title);
      var q = el('span', 'q', '0');
      var pl = el('button', 'pl', '+'); pl.type = 'button'; pl.setAttribute('aria-label', 'Ajouter : ' + r.title);
      stp.appendChild(mn); stp.appendChild(q); stp.appendChild(pl);
      var ls = el('div', 'ls h');
      qc.appendChild(stp); qc.appendChild(ls);

      row.appendChild(bubble(r));
      row.appendChild(nf);
      row.appendChild(qc);
      if (r.min > 1 && !out) row.appendChild(el('div', 'mnote', minNote(r)));
      blk.appendChild(row);

      if (!out) {
        var set = function (val) { S.qty[r.key] = val; q.textContent = val; stp.classList.toggle('z', val === 0); recompute(); };
        pl.onclick = function () { var c = S.qty[r.key] || 0; set(c === 0 ? r.min : c + 1); };
        mn.onclick = function () { var c = S.qty[r.key] || 0; if (c === 0) return; set(c <= r.min ? 0 : c - 1); };
      } else {
        mn.disabled = true; pl.disabled = true;
      }
    });

    var rc = el('div', 'rc');
    var rl = el('div', 'rl');
    rl.appendChild(el('span', 'cnt', 'Aucun format sélectionné'));
    rl.appendChild(el('span', 's2'));
    var gr = el('div', 'gr');
    var gl = el('span', 'tl', 'Total'); gl.style.cssText = 'font-size:13px;color:rgba(18,18,18,.45)';
    var tot = el('span', 't', '0,00 €'); tot.id = 'lpbf-fmt-tot';
    gr.appendChild(gl); gr.appendChild(tot);
    rc.appendChild(rl); rc.appendChild(gr);
    wrap.appendChild(rc);

    var cta = el('button', 'cta', 'Ajouter au panier'); cta.type = 'button'; cta.id = 'lpbf-fmt-cta'; cta.disabled = true;
    cta.onclick = addToCart;
    wrap.appendChild(cta);
    wrap.appendChild(el('div', 'note', '🎁 Livré prêt à offrir · biscuits ensachés par 2'));

    vs.parentNode.insertBefore(wrap, vs);
    hideNatives();
    recompute();
    return true;
  }

  // N'écrire un texte que s'il change : voir le commentaire de txt() dans
  // lpbf-multiformat.js (boucle de réécriture à 60 images/s, clic perdu dans
  // Safari, 24/09/2026).
  function txt(e, v) { if (e) { v = String(v); if (e.textContent !== v) e.textContent = v; } }

  function recompute() {
    var wrap = document.getElementById('lpbf-fmt'); if (!wrap) return;
    var total = 0, formats = 0, nb = 0;
    ROWS.forEach(function (r) {
      var row = wrap.querySelector('.row[data-k="' + r.key + '"]'); if (!row) return;
      var qty = S.qty[r.key] || 0;
      txt(row.querySelector('.q'), qty); row.querySelector('.stp').classList.toggle('z', qty === 0);
      nb += qty * (r.n || 0);
      var up = r.v.price / 100;
      row.classList.toggle('on', qty > 0);
      var ls = row.querySelector('.ls');
      if (qty > 0) { txt(ls, euro(qty * r.v.price)); ls.classList.remove('h'); total += qty * up; formats++; }
      else { ls.classList.add('h'); }
    });
    txt(wrap.querySelector('.cnt'), formats === 0
      ? 'Aucun format sélectionné'
      : (formats + ' format' + (formats > 1 ? 's' : '') + ' sélectionné' + (formats > 1 ? 's' : '')));
    txt(wrap.querySelector('#lpbf-fmt-tot'), (Math.round(total * 100) / 100).toFixed(2).replace('.', ',') + ' €');
    var cta = wrap.querySelector('#lpbf-fmt-cta');
    cta.disabled = formats === 0;
    txt(cta, formats === 0 ? 'Choisissez un format' : 'Ajouter au panier');
    txt(wrap.querySelector('.tl'), nb > 0 ? 'Total · ' + nb + ' biscuit' + (nb > 1 ? 's' : '') : 'Total');
  }

  /* ------------------------------------------------------------------
     8. Ajout au panier (multi-lignes)
     ------------------------------------------------------------------ */
  function readProps() {
    var p = {};
    document.querySelectorAll('input[name^="properties"],textarea[name^="properties"],select[name^="properties"]').forEach(function (e) {
      if ((e.type === 'checkbox' || e.type === 'radio') && !e.checked) return;
      var m = e.name.match(/properties\[(.+?)\]/);
      if (m && e.value && String(e.value).trim() !== '') p[m[1]] = e.value;
    });
    return p;
  }

  function addToCart() {
    var btn = document.getElementById('lpbf-fmt-cta');
    if (!btn || btn.disabled) return;
    var props = readProps(), items = [];
    ROWS.forEach(function (r) {
      var qty = S.qty[r.key] || 0;
      if (qty > 0) items.push({ id: r.v.id, quantity: qty, properties: props });
    });
    if (!items.length) return;

    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Ajout en cours…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
      .then(function (r) {
        btn.textContent = old; btn.disabled = false;
        if (!r.ok) { alert('Ajout impossible : ' + (r.d && r.d.description ? r.d.description : 'erreur')); return; }
        if (r.d.sections) {
          var cd = r.d.sections['cart-drawer'];
          if (cd) {
            var host = document.querySelector('cart-drawer');
            if (host) { var tmp = document.createElement('div'); tmp.innerHTML = cd; var nn = tmp.querySelector('cart-drawer'); if (nn) host.innerHTML = nn.innerHTML; }
          }
          var cb = r.d.sections['cart-icon-bubble'];
          if (cb) {
            var ib = document.getElementById('cart-icon-bubble');
            if (ib) { var t2 = document.createElement('div'); t2.innerHTML = cb; ib.innerHTML = (t2.querySelector('#cart-icon-bubble') || t2).innerHTML; }
          }
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) { drawer.classList.add('active'); } }
          else { drawer.classList.add('active'); }
          document.body.classList.add('overflow-hidden');
        }
        preselect(); recompute();
      })
      .catch(function () { btn.textContent = old; btn.disabled = false; alert('Une erreur est survenue, réessayez.'); });
  }

  /* ------------------------------------------------------------------
     9. Init + auto-réparation (Dawn re-render)
     ------------------------------------------------------------------ */
  function init() {
    if (!build()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (build() || tries > 25) clearInterval(iv); }, 150);
    }
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; build(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
